import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Copy } from "lucide-react";
import { api, useSite, API_URL } from "@/lib/site";
import { inp, Fld, BiText } from "./ui";

export const SettingsAdmin = () => {
  const { reload } = useSite();
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setF({ legal: {}, footer_text: {}, ...r.data })).catch(() => {}); }, []);
  if (!f) return null;
  const set = (k) => (e) => setF((o) => ({ ...o, [k]: e.target.value }));
  const setLegal = (k) => (v) => setF((o) => ({ ...o, legal: { ...o.legal, [k]: v } }));
  const save = async () => {
    try { await api.put("/admin/settings", f); toast.success("Uložené"); reload(); } catch { toast.error("Uloženie zlyhalo"); }
  };
  const fields = [["company", "Názov spoločnosti"], ["address", "Adresa"], ["phone", "Telefón"], ["email", "Verejný e-mail"], ["whatsapp", "WhatsApp číslo (napr. 421900123456)"], ["company_id", "IČO / DIČ"], ["instagram", "Instagram URL"], ["facebook", "Facebook URL"]];
  return (
    <div className="space-y-8 max-w-4xl" data-testid="admin-settings">
      <h2 className="font-display text-3xl text-midnight">Pätička a texty</h2>
      <div className="bg-white border border-gold/50 p-5">
        <Fld label="E-mail pre doručovanie dopytov (neverejný)"><input type="email" className={inp} value={f.inquiry_email || ""} onChange={set("inquiry_email")} data-testid="settings-inquiry-email" placeholder="vas@email.sk" /></Fld>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {fields.map(([k, l]) => <Fld key={k} label={l}><input className={inp} value={f[k] || ""} onChange={set(k)} data-testid={`settings-${k}`} /></Fld>)}
      </div>
      <BiText label="Text v pätičke" value={f.footer_text} onChange={(v) => setF((o) => ({ ...o, footer_text: v }))} testid="settings-footer-text" />
      <BiText label="Obchodné podmienky" area rows={8} value={f.legal.terms} onChange={setLegal("terms")} testid="settings-terms" />
      <BiText label="GDPR" area rows={8} value={f.legal.gdpr} onChange={setLegal("gdpr")} testid="settings-gdpr" />
      <BiText label="Cookies" area rows={8} value={f.legal.cookies} onChange={setLegal("cookies")} testid="settings-cookies" />
      <button className="btn-gold" onClick={save} data-testid="settings-save">Uložiť nastavenia</button>
    </div>
  );
};

export const InquiriesAdmin = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/inquiries").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-inquiries">
      <h2 className="font-display text-3xl text-midnight mb-6">Dopyty</h2>
      {!items.length && <p className="text-midnight/60">Zatiaľ žiadne dopyty.</p>}
      <div className="space-y-3">
        {items.map((q) => (
          <div key={q.id} className="bg-white border border-sand/60 p-5" data-testid={`inquiry-${q.id}`}>
            <div className="flex justify-between gap-4">
              <div>
                <div className="font-display text-xl text-midnight">{q.name}</div>
                <div className="text-sm text-midnight/70"><a href={`mailto:${q.email}`} className="text-gold">{q.email}</a> {q.phone && `· ${q.phone}`}</div>
                {q.property_title && <div className="text-xs text-midnight/60 mt-1">Nehnuteľnosť: {q.property_title}</div>}
              </div>
              <div className="text-right text-xs text-midnight/50 shrink-0">
                {new Date(q.created_at).toLocaleString("sk-SK")}<br />{q.emailed ? "E-mail odoslaný" : "Len uložené"}
                <button onClick={async () => { await api.delete(`/admin/inquiries/${q.id}`); load(); }} className="block ml-auto mt-2 hover:text-red-600"><Trash2 size={14} /></button>
              </div>
            </div>
            {q.message && <p className="mt-3 text-sm text-midnight/80 whitespace-pre-line">{q.message}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export const FeedAdmin = () => {
  const links = [["JSON feed", `${API_URL}/feed.json`], ["XML feed", `${API_URL}/feed.xml`], ["Sitemap", `${API_URL}/sitemap.xml`]];
  return (
    <div data-testid="admin-feed" className="max-w-3xl">
      <h2 className="font-display text-3xl text-midnight mb-3">Exportný feed</h2>
      <p className="text-sm text-midnight/70 mb-6">Feed sa generuje vždy aktuálne zo zverejnených nehnuteľností. Odkaz stačí zadať do realitného portálu.</p>
      {links.map(([l, u]) => (
        <div key={l} className="flex items-center gap-3 bg-white border border-sand/60 p-4 mb-3">
          <span className="text-xs tracking-[0.2em] uppercase w-28 text-midnight/60">{l}</span>
          <a href={u} target="_blank" rel="noreferrer" className="flex-1 text-sm text-midnight truncate hover:text-gold" data-testid={`feed-link-${l.split(" ")[0].toLowerCase()}`}>{u}</a>
          <button onClick={() => { navigator.clipboard?.writeText(u); toast.success("Skopírované"); }} className="text-midnight/50 hover:text-gold"><Copy size={16} /></button>
        </div>
      ))}
    </div>
  );
};
